import { FleetPerformanceCard } from "../components/FleetPerformanceCard";
import { MainServiceCard } from "../components/MainServiceCard";
import { IdwalServices } from "../config/services";

const ServicesPage = () => {
    // Separate Jira Orchestration from other services
    const jiraOrchestration = IdwalServices.find(service => service.id === "jira-orchestration");
    const otherServices = IdwalServices.filter(service => service.id !== "jira-orchestration" && service.id !== "fleet-performance");
    const fleetPerformance = IdwalServices.find(service => service.id === "fleet-performance");
    
    return (
        <div className="flex flex-column py-4">
            <div
                onClick={() => location.reload()}
                className="cursor-pointer select-none link-hover flex justify-content-start ml-3"
            >
                <small>Refresh</small>
                <i
                    className="pi pi-refresh pl-1"
                    style={{ fontSize: "1em", marginTop: -2 }}
                ></i>
            </div>

            {/* Jira Orchestration - Full width */}
            {jiraOrchestration && (
                <MainServiceCard key={jiraOrchestration.id} serviceGroup={jiraOrchestration} />
            )}

            {/* Other services - 2 side by side */}
            <div className="grid">
                {otherServices.map((service) => (
                    <div key={service.id} className="col-12 md:col-6">
                        <MainServiceCard serviceGroup={service} />
                    </div>
                ))}
            </div>

            {/* Fleet performance - Full width */}
            {fleetPerformance && (
                <FleetPerformanceCard key={fleetPerformance.id} serviceGroup={fleetPerformance} />
            )}
        </div>
    );
};

export default ServicesPage;
